﻿$('#contactForm').validator().on('submit', function (e) {

    if (e.isDefaultPrevented()) {
        // handle the invalid form...
    } else {
        // everything looks good!
        e.preventDefault();
        // get values from FORM
        var formname = $("input#formname").val();
        var name = $("input#name").val();
        var email = $("input#email").val();
        var companyname = $("input#companyname").val();
        var field1 = $("select#ecommerceplatform").val();
        var field2 = $("select#paymentprocessor").val();
        var field3 = "";

        $.ajax({
            url: "/api/contactme",
            type: "POST",
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            data: JSON.stringify({
                formname: formname,
                name: name,
                email: email,
                companyname: companyname,
                field1: field1,
                field2: field2,
                field3: field3
            }),
            cache: false,
            success: function (response) {
                // Success message
                $('#success').html("<div class='alert alert-success'>");
                $('#success > .alert-success').html("<button type='button' class='close' data-dismiss='alert' aria-hidden='true'>&times;")
                    .append("</button>");
                $('#success > .alert-success')
                    .append("<strong>Your message has been sent. </strong>");
                $('#success > .alert-success')
                    .append('</div>');

                //clear all fields
                $('#contactForm').trigger("reset");
            },
            error: function (xhr, ajaxOptions, thrownError) {
                // Fail message
                $('#success').html("<div class='alert alert-danger'>");
                $('#success > .alert-danger').html("<button type='button' class='close' data-dismiss='alert' aria-hidden='true'>&times;")
                    .append("</button>");
                $('#success > .alert-danger').append("<strong>Sorry " + name + ", it seems that my mail server is not responding. Please try again later!");
                $('#success > .alert-danger').append('</div>');
                //clear all fields
                $('#contactForm').trigger("reset");
            },
        });
    }
})